// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"c015298b","2546":"c0b47e18","2620":"152e40f6"}[chunkId] + ".chunk.css";
};